/**
 * Form validation — HTML5 constraint validation + OctoberCMS AJAX error display.
 * Uses jQuery from OctoberCMS globals (window.$).
 */
/* global $ */

export function initValidation() {
  // Display AJAX error messages in .error-message elements
  $(window).on('ajaxErrorMessage', (event, message) => {
    $('.error-message').show().text(message.trim());
    event.preventDefault(); // Prevent default alert()
  });

  // HTML5 constraint validation for forms with .needs-validation
  document.querySelectorAll('.needs-validation').forEach(form => {
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    });
  });
}
